import React from 'react';

import Icon, { IconKey } from 'flow/components/ui-components/Icon';
import { useAppSelector } from 'flow/hooks/useRedux';
import { CallRecordKey } from 'flow/types/EntityKeys';
import { selectCallRecordFromKey } from 'flow/selectors/call-selectors';
import {
    callRecordIsIncoming,
    callRecordIsMissed,
    isCallRecordAMeeting,
    queueCallRecordOnHookWaitingOrdered,
} from 'flow/utils/call-records-utils';
import { twMerge } from 'tailwind-merge';

interface Props {
    callRecordKey: CallRecordKey;
    className?: string;
    size?: string;
}

const CallRecordTypeIcon = ({ callRecordKey, className, size }: Props) => {
    const callRecord = useAppSelector((state) =>
        selectCallRecordFromKey(state, callRecordKey),
    );

    if (!callRecord) return null;

    const isMeeting = isCallRecordAMeeting(callRecord);
    const isIncoming = callRecordIsIncoming(callRecord);
    const isMissed = callRecordIsMissed(callRecord);

    let iconKey: IconKey = 'callerid';
    let colorClass = 'text-gray-900';

    if (isMeeting) {
        iconKey = 'video';
    } else if (queueCallRecordOnHookWaitingOrdered(callRecord)) {
        iconKey = 'phone_callback';
    } else if (isIncoming) {
        iconKey = isMissed ? 'missedCalls' : 'incoming';
        colorClass = isMissed ? 'text-red' : 'text-gray-900';
    }

    return (
        <Icon
            className={twMerge(
                'me-2 size-6 rtl:scale-x-[-1]',
                colorClass,
                className,
            )}
            iconKey={iconKey}
            size={size}
        />
    );
};

export default React.memo(CallRecordTypeIcon);
